import { Controller } from "@hotwired/stimulus"

// Connecte le contrôleur au DOM et définit des cibles
export default class extends Controller {
  static targets = ["assuranceSelect", "formuleSelect"]

  connect() {
    // Initialiser le contrôleur
    
    // Stocker la formule actuellement sélectionnée pour la préserver
    this.currentFormuleId = this.formuleSelectTarget.value
    
    // Si une assurance est déjà sélectionnée ET qu'on n'a pas de formule sélectionnée, 
    // alors on charge les formules disponibles
    const assuranceId = this.assuranceSelectTarget.value
    if (assuranceId && (!this.currentFormuleId || this.currentFormuleId === '')) {
      this.assuranceChanged()
    }
  }

  // Méthode appelée lorsque l'assurance change
  async assuranceChanged() {
    // Ne stocker la formule que si ce n'est pas lors de l'initialisation
    if (!this.currentFormuleId) {
      this.currentFormuleId = this.formuleSelectTarget.value
    }
    
    // Récupérer l'ID de l'assurance sélectionnée
    const assuranceId = this.assuranceSelectTarget.value
    
    // Si aucune assurance n'est sélectionnée, réinitialiser le sélecteur de formule
    if (!assuranceId) {
      this.resetFormuleSelect()
      this.currentFormuleId = null
      return
    }
    
    // Ajouter un message de chargement au sélecteur
    this.resetFormuleSelect()
    const loadingOption = document.createElement('option')
    loadingOption.textContent = "Chargement des formules..."
    loadingOption.disabled = true
    loadingOption.selected = true
    this.formuleSelectTarget.appendChild(loadingOption)
    
    // Charger les formules associées à cette assurance
    try {
      const url = `/admin/formules/by_assurance/${assuranceId}.json`
      
      const response = await fetch(url)
      
      if (!response.ok) {
        throw new Error(`Erreur HTTP: ${response.status}`)
      }
      
      const formules = await response.json()
      
      // Mettre à jour le sélecteur de formule
      this.updateFormuleSelect(formules)
    } 
    catch (error) {
      this.resetFormuleSelect()
      
      // Ajouter un message d'erreur
      const errorOption = document.createElement('option')
      errorOption.textContent = "Erreur lors du chargement des formules"
      errorOption.disabled = true
      this.formuleSelectTarget.appendChild(errorOption)
    }
  }
  
  // Mettre à jour le sélecteur de formule avec les options récupérées
  updateFormuleSelect(formules) {
    // Vider le sélecteur sauf la première option
    this.resetFormuleSelect()
    
    // Créer et ajouter les nouvelles options
    formules.forEach(formule => {
      const option = document.createElement('option')
      option.value = formule.id
      option.textContent = formule.nom
      this.formuleSelectTarget.appendChild(option)
    })
    
    // Restaurer la sélection précédente si elle existe dans les nouvelles options
    if (this.currentFormuleId && this.currentFormuleId !== '') {
      const formuleExists = formules.find(f => f.id.toString() === this.currentFormuleId.toString())
      if (formuleExists) {
        this.formuleSelectTarget.value = this.currentFormuleId
      }
    }
  }
  
  // Réinitialiser le sélecteur de formule à son état initial
  resetFormuleSelect() {
    // Conserver uniquement la première option (généralement "Sélectionner une formule")
    const defaultOption = this.formuleSelectTarget.querySelector('option:first-child')
    this.formuleSelectTarget.innerHTML = ''
    if (defaultOption) {
      this.formuleSelectTarget.appendChild(defaultOption)
    }
  }
}